import { ValidatorStates } from '@chegg-wt/core/state/citation/constants'
import { CitationData } from '@chegg-wt/core/types/form'

import $ from 'jquery'
import { SiteTheme } from '../theme/styled'

// cod

let pubtab // Module level let is needed further below
/* eslint-disable */

let eventsToUnmount = []
export function unmountFormPageEvents() {
  eventsToUnmount.forEach(function (eventConfig) {
    let $eventTarget = $(eventConfig.target)
    let offArgs = eventConfig.args
    $eventTarget.off.apply($eventTarget, offArgs)
  })
}

export function unmountTabs() {
  $('.form_tabheaders').remove()
}

const checkMissingRecommendedFields = () =>
  $('input.recommendedHighlightEmpty:visible').length > 0

/**

 * Initial citation data to fill the form.
 * This will also be used when submitting the form to send autocite feedback
 * Legacy js file content has been copied here, therefore some of the "new"
 * functions are called at the end of this file.
 */
let initialCitationData

interface SubmitFormArgs {
  onComplete: (
    citation: CitationData,
    initialCitationData: any,
    annotationText?: string
  ) => void
}

export function submitForm({ onComplete }: SubmitFormArgs) {
  let citationData: CitationData = formDataToJson()

  onComplete({ ...citationData }, initialCitationData, citationData.annotation)
}

function redesignForm(style, onChangeSourceType, theme: SiteTheme) {
  let $form = $('#citation_form')

  // Hide unneeded elements
  $form.find('.section_autocite').remove()
  $form.find('table').addClass('table')

  // Add class to all inputs
  $form.find('input:not([type="checkbox"])').addClass('form-control')

  // theming for form inputs
  if (document.styleSheets[0]) {
    document.styleSheets[0].addRule(
      '#citation_form input:not([type="checkbox"]):focus',
      `border-color: ${theme.Colors.primaryColor}!important`
    )
    document.styleSheets[0].addRule(
      '#citation_form select:focus',
      `border-color: ${theme.Colors.primaryColor}!important`
    )
    document.styleSheets[0].addRule(
      '#citation_form textarea:focus',
      `border-color: ${theme.Colors.primaryColor}!important`
    )
  }

  // Fix Contributors label
  let $contribLabel = $('.section_contributors table').eq(0).find('label').eq(0)
  $('.section_contributors').prepend($contribLabel.clone())
  $contribLabel.parent('td').remove()

  // Fix everything
  changeTabsToButton()
  fixFormLabel($form)
  fixContribPositionLabel($form)
  fixAddContribLink()
  fixRemoveContrib()
  fixAddAnnotation()
  fixApa7form(style)
  addWebsitePublicationValidation()
  nameLabelFixes()
  displayUrlMLA7Fixes()
  bindBookCitationSelect()
  bindTodayButton()
  bindSourceTypeSelect(onChangeSourceType)
  hideSingleTab()
  addTabsWrapper()
  addTopDescription()
  fixSourceSectionA11y()
  fixContributorsSectionA11y()
  fixAnnotationSectionA11y()
  fixPublicationsA11y()
}

function getStarIcon() {
  let path =
    'M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z'
  let svg =
    '<svg class="material-icons icon-grade" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">'
  svg += '<title>star icon indicating recommended field</title><path d="' + path + '"/>'
  svg += '<path d="M0 0h24v24H0z" fill="none"/></svg>'
  return svg
}

function fixContributorsSectionA11y() {
  let $contributorsLabel = $('.section_contributors label:first')
  $contributorsLabel.wrap('<div id="contributors-label"></div>')

  let $contributorsTable = $('.section_contributors table:first')
  $contributorsTable.wrap('<div role="group" aria-labelledby="contributors-label"></div>')
}

function fixSourceSectionA11y() {
  let $whatIamciting = $('.first-header')
  let $elementsTillContributors = $('.first-header')
    .nextUntil('.section_source')
    .add('.section_source')

  $whatIamciting.wrap('<div id="whatiamciting-label"></div>')
  $elementsTillContributors.wrapAll(
    '<div role="group" aria-labelledby="whatiamciting-label"></div>'
  )
}

function fixAnnotationSectionA11y() {
  let $annotationSection = $('.section_annotation')
  $annotationSection.attr('id', 'annotation-label')

  let $annotationDiv = $('#annotation')
  $annotationDiv.attr({ role: 'group', 'aria-labelledby': 'annotation-label' })
}

function fixPublicationsA11y() {
  const pubClassNames = [
    'pubnonperiodical',
    'pubonline',
    'pubdatabase',
    'pubother',
    'pubjournal',
    'pubabstractsjournal',
    'pubnewspaper',
    'pubfederal',
    'pubfilm',
    'pubmagazine',
  ]
  pubClassNames.forEach((pubClassName) => {
    // handle header
    const $wrapperDiv = $(`.section_publication .${pubClassName}`)
    const $header = $(`.${pubClassName} .suffix_header`)
    const newHeader = `<div id="${pubClassName}-label"><label role="heading" aria-level="3" class="sec-header">${$header.text()}</label></div>`
    $header.remove()
    $wrapperDiv.prepend(newHeader)

    // handle form controls
    const $formTable = $wrapperDiv.find('table:first')
    $formTable.wrap(`<div role="group" aria-labelledby="${pubClassName}-label"></div>`)
  })
}

/**
 * Add a description about recommended fields
 * @see https://github.com/easybib/sbm-issues/issues/1905
 */
function addTopDescription() {
  let icon = getStarIcon()
  let text =
    'Add in any information you have below. The starred boxes are strongly suggested.'
  let $formInner = $('#form-inner > div')
  let $desc = $(
    '<div class="top-desc">' +
      '<p>' +
      icon +
      text +
      '</p></div><h2 class="first-header">What I\'m citing</h2>'
  )
  $formInner.prepend($desc)
}

/**
 * Add star icon to recommended fields when empty
 * @see https://github.com/easybib/sbm-issues/issues/1905
 */
function addStarIcons() {
  let emptyClass = 'recommendedHighlightEmpty'

  $('.recommended').each(function () {
    $(getStarIcon()).insertBefore($(this))
    if (
      typeof $(this).val() !== undefined &&
      (!$(this).val() || String($(this).val()).trim() === '')
    ) {
      $(this).addClass(emptyClass)
    }
  })

  $('svg.icon-grade').each(function () {
    // Some inputs have no <span> around <svg><input> so add one to be able to
    // correctly position the star icon.
    let $parent = $(this).parent()
    let parentNode = $parent[0].localName

    if (parentNode === 'p') return // top-desc
    if (parentNode === 'span') {
      if ($(this).next('input').hasClass(emptyClass)) $parent.addClass(emptyClass)
      return
    }
    let spanClass = 'input-wrapper'
    if ($(this).next('input').hasClass(emptyClass)) spanClass += ' ' + emptyClass
    let span = '<span class="' + spanClass + '"></span>'
    $parent.wrapInner($(span))
  })
}

function addTabsWrapper() {
  let $tabs = $('.form_tabheaders')
  let $tab = $('.tabheader')
  let $outer = $('.form-outer')
  if ($tab.length < 2) return
  $tabs.insertBefore($outer)
}

function addWebsitePublicationValidation() {
  let $day = $('input[name="pubonline[day]"]')
  let $year = $('input[name="pubonline[year]"]')
  if ($year.length === 0 && $day.length === 0) {
    return
  }
  let date = new Date()
  let dateYear = date.getFullYear()
  $day.attr('min', 1).attr('max', 31).attr('maxlength', 2)
  $year.attr('min', 1).attr('max', dateYear).attr('maxlength', 4)
}

/**
 * "Add annotation" link and textarea aren't part of the form so add it
 * https://github.com/easybib/sbm-issues/issues/1483
 */
function addAnnotationLink(onUserClickAddAnnotationCTA: () => void) {
  let $pub = $('.section_publication')
  let $doi = $('.section_doi')
  let $lastDiv = $doi.length > 0 ? $doi : $pub
  let firstClick = true
  let $icon = $('.material-icons.icon-add_circle').clone().remove()
  $icon.removeClass('hidden')
  $icon.children('title').attr('id', 'icon-add-annotation')
  let $annotationDiv =
    '<div class="section_annotation"> <a href="" class="annotation_add"> Add annotation</a></div>'
  $annotationDiv +=
    '<div id="annotation" class="annotation-text"><textarea name="annotation[text]" class="annotation"></textarea></div>'
  $annotationDiv += '</div>'
  $lastDiv.after($annotationDiv)
  $('.annotation_add').prepend($icon)
  $('a.annotation_add').on('click touchstart', function (e) {
    e.preventDefault()
    onUserClickAddAnnotationCTA()
    $('#annotation').show()
    // // Super circonvoluted logic to reproduce behavior of EB legacy form js...
    if (firstClick && String($('#annotation textarea').val()).trim() === '') {
      $('#annotation textarea').hide()
      $('#annotation textarea').slideToggle('400')
      firstClick = false
    }
    $('a.annotation_add').hide()
    $('#annotation').css({ 'margin-top': '-40px' })
  })
}

function fixAddAnnotation() {
  $('.section_annotation').prepend('<h3>More options</h3>')
  $('#annotation textarea').attr('id', 'annotation[text]')
  $('#annotation').prepend('<label for="annotation[text]">Annotation</label>')

  // add a remove annotation button.
  let $deleteIcon = $('.material-icons.icon-delete').first().clone()
  $deleteIcon.removeClass('hidden')
  $deleteIcon.children('title').attr('id', 'icon-delete-annotation')
  let $button = $(
    '<button class="btn annotation_del" type="button" aria-label="delete annotation"></button>'
  )
  $button.append($deleteIcon)
  $('#annotation').append($button)
  $('.annotation_del').on('click touchstart', function (e) {
    e.preventDefault()
    $('#annotation textarea').val('')
    $('#annotation').hide()
    $('a.annotation_add').show()
    $('#annotation').css({ 'margin-top': '0px' })
  })
}

function fixApa7form(style) {
  if (style !== 'apa7') return
  const source = $('#source').val()

  // Publisher city and state removed in APA7 for these sources
  // Must be removed instead of hidden for validator
  if (source === 'book' || source === 'chapter') {
    const inputClasses = ['.pubnonperiodical_city', '.pubnonperiodical_state'].join()

    $(inputClasses).closest('td').remove()
  }

  if (source === 'musicalrecording') {
    // Remove "Location Recorded" input
    $('#musicalrecording\\[location\\]').closest('tr').remove()

    // Remove entire "Media Publication Info" section
    $('.section_publication').remove()
  }
}

/**
 * If there is only one tab in the top menu hide it
 */
function hideSingleTab() {
  let $tabs = $('.tabheader')
  if ($tabs.length === 1) {
    $tabs.hide()
  }
}

/**
 * Change the tabs to buttons for accessibility
 */

function changeTabsToButton() {
  let $tabs = $('.tabheader')
  $tabs.each((i, e) => {
    let el = e.children[0]
    let klass = el.getAttribute('class')
    let text = el.textContent
    const ariaPressed = i === 0 ? 'true' : 'false'
    el.innerHTML = `<button type="button" class="${klass}" aria-pressed="${ariaPressed}">${text}</button>`
  })
}

/**
 * On website/newspaper/magazine forms, the first select redirects to another form
 */
function bindSourceTypeSelect(onChangeSourceType: (type: string) => void) {
  $('select.redirect_pulldown').on('change', function () {
    let tab = $(this).attr('id').replace('pubtab_', '')
    let type = <string>$(this).val()
    /**
     * Special case for newspaper and magazine which have values like:
     * - editorial_pubmagazine_pubonline
     * - editorial_pubnewspaper_pubonline
     * - review_pubnewspaper_pubonline
     * - review_pubmagazine_pubonline
     */
    if (type.includes('_pubonline')) {
      let split = type.split('_')
      type = split[0]
      tab = split[1]
    }

    onChangeSourceType(type)
  })
}

function nameLabelFixes() {
  // Contributors field names from "First" and "last / corp." to "First Name" and "Last Name"
  let $firstNameLabel = $('label[for=' + $('input.contributors_first').attr('id') + ']')
  $firstNameLabel.text('First Name')
  let $lastNameLabel = $('label[for=' + $('input.contributors_last').attr('id') + ']')
  $lastNameLabel.text('Last Name')
}

function fixContribPositionLabel($form) {
  // Contributors missing field label "Position" fix
  $form.find('select.contributors_function').each(function () {
    let that = $(this)
    let $label = that.closest('td').children('label')
    if ($label.length > 0 && !$label.is(':empty')) return

    let formElementId = that.attr('id')
    if (!formElementId) {
      formElementId = inputId(that)
    }
    let $newLabel = $('<label for="' + formElementId + '">Position</label>')
    let $wrapper = $('<span class="input-wrapper"></span>')
    that.before($newLabel)
    that.wrap($wrapper)
  })
}

function displayUrlMLA7Fixes() {
  // Online tab fix
  $('#show-url-yes, #show-url-no').parent().addClass('display-url')
  $('label[for=show-url-yes]')
    .last()
    .parent()
    .append($('label[for=show-url-yes]').last().remove())
  $('label[for=show-url-yes]:nth(1)').remove()

  // Online Database tab fix
  $('#show-dburl-yes, #show-dburl-no').parent().addClass('display-url')
  $('label[for=show-dburl-yes]')
    .last()
    .parent()
    .append($('label[for=show-dburl-yes]').last().remove())
  $('label[for=show-dburl-yes]:nth(0)').remove()
}

/**
 * Today button/link fills today data into "Date accessed"
 */
function bindTodayButton() {
  let $today = $('.today')
  $today.text("Use Today's Date").on('click touchstart', function (e) {
    e.preventDefault()
    let date = new Date()
    let day = ('0' + date.getDate()).slice(-2)
    let month = date.getMonth() + 1
    let year = date.getFullYear()
    $('.day:last').val(day).change()
    $('.month:last').prop('selectedIndex', month).change()
    $('.year:last').val(year).change()
  })
}

/**
 * On book-citation form, when the first select ("Citing") is changed, we redirect to the
 * corresponding form page ("chapter" or "introduction").
 * The original form is hidden on the page as form#original-citation
 */
function bindBookCitationSelect() {
  // turn off the crashy original change event, that needs DatabaseTabController.
  $('.redirect_pulldown').off('change')
}

function checkMissingFields() {
  let emptyClass = 'recommendedHighlightEmpty'
  let $form = $('#citation_form')
  let $recommended = $form.find('.recommended')
  $recommended.each(function () {
    if ($(this).val() && String($(this).val()).trim() === '') $(this).addClass(emptyClass)
  })
  $form.find('input, select').change(function () {
    if ($(this).val() && String($(this).val()).trim() !== '') {
      $(this).removeClass(emptyClass)
      $(this).parent('span').removeClass(emptyClass)
    } else {
      if (!$(this).hasClass(emptyClass)) {
        $(this).addClass(emptyClass)
        $(this).parent('span').addClass(emptyClass)
      }
    }
  })
  // Now we can add the star icons
  addStarIcons()
}

/**
 * <input><p><span><label> -> <label /><span><input>
 */
let uniqueIds = 666
function inputId($formElement) {
  // gets the form elements id. Creates one if it's not there.
  let form_el_id = $formElement.attr('id')
  if (!form_el_id) {
    form_el_id = 'form_el_' + uniqueIds
    uniqueIds++
    $formElement.attr('id', form_el_id)
  }
  return form_el_id
}
function fixFormLabel($form) {
  $form.find('td').each(function () {
    if ($(this).has('p.sub_label_bottom').length === 0) return

    let $formElement = $(this).children('input')
    if ($formElement.length === 0) $formElement = $(this).children('select')
    let $label = $(this).children('p.sub_label_bottom')

    if ($label.length === 0) return

    let text = $label.children('span').html()
    let formElementId = inputId($formElement)

    let $newLabel = $('<label for="' + formElementId + '">' + text + '</label>')
    let $wrapper = $('<span class="input-wrapper"></span>')
    $formElement.before($newLabel)
    $formElement.wrap($wrapper)
    $label.remove()
  })
  // fix up the inputs to have unique ids.
  $form.find('input').each(function () {
    if (!$(this).attr('id') && $(this).attr('name')) {
      $(this).attr('id', $(this).attr('name'))
    }
  })
  // fix checkboxes to be wrapped in a label, and text in a span.
  $form.find('input[type="checkbox"]').each(function (index, el) {
    $(el).parent().wrapInner('<label></label>')
    $(el)
      .parent()
      .each(function (index, v) {
        $(v).contents().eq(1).wrap('<span class="label-span" />')
      })
  })
  /**
   * fix up inputs and selects to have aria label. it will apply to:
   * - radio inputs without labels
   * - inputs which fail to add label with block element, i.e.: DOI field
   * - selects without labels
   */
  $form.find('input, select').each(function () {
    if ($(this).attr('aria-label')) return

    let $label = $(this).closest('td').children('label')
    if ($label.length > 0 && !$label.is(':empty')) return

    let ariaLabel = $(this).attr('name') || $(this).attr('id')
    $(this).attr('aria-label', ariaLabel)
  })
}

function fixAddContribLink() {
  let $addLink = $('td.add_another_contributor_row a')
  let $addIcon = $('.material-icons.icon-add_circle').eq(0).clone().remove()
  $addIcon.removeClass('hidden')
  $addIcon.children('title').attr('id', 'icon-add-contributor')
  $addLink.html(($addIcon as unknown) as Element)
  $addLink.append('Add another contributor')
  $addLink.parents('tr').first().remove()
  $addLink.detach()
  $addLink.css('display', 'flex')
  $('.section_contributors table').first().after($addLink)
}

function oneContrib() {
  return $('tr.contributors_table_row').length === 1
}

function empty($dom) {
  return $dom.val() === ''
}

function emptyContrib($parent) {
  let $first = $parent.find('.contributors_first')
  let $middle = $parent.find('.contributors_middle')
  let $last = $parent.find('.contributors_last')
  let $suffix = $parent.find('.contributors_suffix')

  return empty($first) && empty($middle) && empty($last) && empty($suffix)
}

function fixRemoveContrib() {
  let css = 'btn remove-contrib'
  // Disable delete button for first contributors row if only one contributor
  const isDisabled = oneContrib() && emptyContrib($('tr.contributors_table_row:first'))
  css += isDisabled ? ' disabled' : ''

  $('a.btn-remove').each(function (index) {
    let $that = $(this)
    let $deleteIcon = $('.material-icons.icon-delete').first().clone()
    $deleteIcon.removeClass('hidden')
    $deleteIcon.children('title').attr('id', `icon-remove-contributor-${index}`)
    let $button = $(
      '<button style="background-color:white;display:flex;margin-bottom:2px;" class="' +
        css +
        '" aria-label="remove contributor" ' +
        (isDisabled ? 'disabled="disabled"' : '') +
        '"></button>'
    )
    $button.append($deleteIcon)
    $that.replaceWith($button)
  })

  // Enable/disable remove button on edit
  let keyupHandlerForContribInputs = function () {
    let disabled = 'disabled'
    let $row = $(this).parents('tr.contributors_table_row')
    let $button = $row.find('button.remove-contrib')

    $button.attr('type', 'button')
    if (emptyContrib($row)) {
      if (!$button.hasClass(disabled)) {
        $button.addClass(disabled)
        $button.attr('disabled', 'disabled')
      }
    } else {
      $button.removeClass('disabled')
      $button.attr('disabled', null)
    }
  }
  $('body').on(
    'keyup',
    '.contributors_first, .contributors_middle, .contributors_last, .contributors_suffix',
    keyupHandlerForContribInputs
  )
  eventsToUnmount.push({
    target: 'body',
    args: [
      'keyup',
      '.contributors_first, .contributors_middle, .contributors_last, .contributors_suffix',
      keyupHandlerForContribInputs,
    ],
  })

  // Removing contributor handling.
  $('body')
    .on('click touchstart', 'button.remove-contrib', function (e) {
      e.preventDefault()
      let $tr = $(this).parents('tr.contributors_table_row')
      if ($(this).hasClass('disabled')) {
        return false
      }
      if (oneContrib()) {
        $tr.find('input').val('')
        $(this).addClass('disabled')
        // Fix receommended outline missing after emptying
        let $recommended = $tr.find('.recommended')
        $recommended.each(function () {
          if (
            $(this).hasClass('recommended') &&
            !$(this).hasClass('recommendedHighlightEmpty') &&
            $(this).val() === ''
          ) {
            $(this).addClass('recommendedHighlightEmpty')
          }
        })
      } else {
        $tr.remove()
      }
    })
    .attr('type', 'button')
}

// formDataToJson is from the legacy js.
function getSection(formfield) {
  return formfield.substring(0, formfield.indexOf('['))
}
function getColumn(formfield) {
  return formfield.substring(formfield.indexOf('[') + 1, formfield.indexOf(']'))
}

export function formDataToJson() {
  let formData = {} as CitationData
  formData.source = $('#source').val() as CitationData['source']

  if (typeof formData.source == 'undefined') {
    formData.source = $('input[name=source]').val() as CitationData['source']
  }

  formData.pubtype = {
    main: $('#pubtype').val() as string,
    suffix: $('#pubsuffix').val() as string,
  }

  let fields = $('#citation_form').find(
    'input:radio:checked, input:text, select, input:checkbox:checked'
  )
  let other = $('.section_publication input[type=hidden]:not("#pubtype, #pubsuffix")')

  fields = fields.add(other)
  $(fields).each(function () {
    let fieldName = $(this).attr('name')
    if (typeof fieldName != 'undefined' && fieldName.length > 0) {
      let valueName = $(this).attr('name')
      let valueSection = getSection(valueName)
      let valueColumn = getColumn(valueName)
      if (typeof formData[valueSection] == 'undefined') {
        formData[valueSection] = {}
      }
      formData[valueSection][valueColumn] = $(this).val()
    }
  })
  formData.contributors = []
  $('#citation_form .contributors_table_row').each(function (i) {
    let contribRow = {}
    contribRow['function'] = $(this).find('.contributors_function').val()
    contribRow['first'] = $(this).find('.contributors_first').val()
    contribRow['middle'] = $(this).find('.contributors_middle').val()
    contribRow['last'] = $(this).find('.contributors_last').val()
    contribRow['data'] = {}
    contribRow['data']['suffix'] = $(this).find('.contributors_suffix').val()
    formData.contributors.push(contribRow)
  })
  if ($('#custom-citation') && $('#custom-citation').val()) {
    formData.custom = { citation: $('#custom-citation').val() }
  }

  formData.annotation = ($('textarea.annotation').val() as string)?.trim()

  formData.validatorStatus = checkMissingRecommendedFields()
    ? ValidatorStates.MISSING
    : ValidatorStates.COMPLETE

  return formData
}
// formDataToJson is from the legacy js.

interface LegacyJsArgs {
  style: string
  citation?: any
  theme?: SiteTheme
  onChangeSourceType: (sourceType: string) => void
  onUserClickAddAnnotationCTA: () => void
  onUserClickAddContributorsCTA: () => void
}
export function legacyJs({
  style,
  citation,
  theme,
  onChangeSourceType,
  onUserClickAddAnnotationCTA,
  onUserClickAddContributorsCTA,
}: LegacyJsArgs): void {
  eventsToUnmount = []

  /**
   * Forms related functions
   */
  $('#source, #style').on('change', function () {
    location.href = 'form?style=' + $('#style').val() + '&source=' + $('#source').val()
  })

  //pulldowns
  let pulldown_redirect = true

  function postRedirect(uri, data) {
    let form = $('<form style="display:none" method="POST" action="' + uri + '"></form>')
    for (let name in data) {
      let field = $('<input type="hidden">')
      field.attr('name', name)
      field.attr('value', data[name])
      form.append(field)
    }
    $('body').append(form)
    form.submit()
  }

  function pubFormRedirect(from, to, pubtab) {
    let redirect_data: CitationData | string = formDataToJson()
    let storeSplit = to.split('_')
    if (redirect_data[from] != undefined) {
      redirect_data[storeSplit[0]] = redirect_data[from]
      redirect_data[from] = {}
    }

    if (storeSplit.length === 3) {
      redirect_data.source = storeSplit[0]
      redirect_data.pubtype.main = storeSplit[1]
      redirect_data.pubtype.suffix = storeSplit[2]
    } else {
      redirect_data.source = storeSplit[0]
      if (pubtab.length > 0) {
        pubtab = '/pubtab/' + pubtab
      }
    }

    redirect_data = JSON.stringify(redirect_data)

    let edit_id = false
    if (
      $('#edit_id').val() !== undefined &&
      ($('#edit_id').val() as string[]).length > 0
    ) {
      edit_id = true
    }
    if (pulldown_redirect) {
      let postData: { data: CitationData | string; toolbar?: string } = {
        data: redirect_data,
      }
      if (edit_id) {
        postRedirect(location.href, postData)
      } else {
        if (location.href.match(/toolbar=true/) !== null) {
          postData.toolbar = 'true'
        }
        postRedirect('/cite/form/' + storeSplit[0] + pubtab, postData)
      }
    }
  }
  $('#redirect_pulldown_cancel').click(function () {
    pulldown_redirect = false
    $('#redirect_pulldown_message').hide()
  })
  $('.redirect_pulldown').change(function () {
    let source_to_redirect = $(this).val() as string
    let pubtab: string | string[] = ''

    let pubtabid = $(this).attr('id') || ''
    if (pubtabid.length > 0) {
      pubtab = pubtabid.split('_')
      pubtab = pubtab[1]
    }

    let sourceKey = source_to_redirect.split('_')
    if (typeof sourceKey[0] !== 'undefined' && sourceKey[0] === 'jstor') {
      // return here because we dont want to have redirect as done below
      // DatabaseTabController.enableAutociteInterface()
      return
    }

    $('[data-id=source-form]').hide()
    // DatabaseTabController.showDBLinksInterface()
    if (source_to_redirect.length > 1) {
      $('#redirect_pulldown_message').slideDown()
      pulldown_redirect = true

      $('[data-id=search-result-headline]').hide()
      let resultContainer = $('[data-id=results]')
      if (resultContainer.length == 0) {
        resultContainer = $('<div data-id="results" class="results" ></div>')
        $('#content').append(resultContainer)
      }
      resultContainer.html(
        '<div class="results-message" data-id="searching-for-results">Sending you to the appropriate form...</div>'
      )
      setTimeout(
        "pubFormRedirect('" +
          $('#source').val() +
          "','" +
          source_to_redirect +
          "', '" +
          pubtab +
          "')",
        900
      )
    }
  })

  //dictionary & encyclopedia
  $('#check-wellknown').click(function (event) {
    $('#section-wellknown').slideToggle('slow')
  })

  if ($('#style').val() == 'apa') {
    let sv = $('#source').val()
    if (sv == 'dictionary' || sv == 'encyclopedia') {
      $('#main_pubnonperiodical_suffix_pubonline').click(function (event) {
        $(
          '.pubnonperiodical_vol, .pubnonperiodical_publisher, .pubnonperiodical_city, .pubnonperiodical_state'
        )
          .parent()
          .hide()
          .find('input')
          .val('')
        $('.pubnonperiodical_start')
          .parent()
          .parent()
          .parent()
          .parent()
          .parent()
          .parent()
          .hide()
          .find('input')
          .val('')
      })
      $('#main_pubnonperiodical, #main_pubnonperiodical_suffix_pubdatabase').click(
        function (event) {
          $(
            '.pubnonperiodical_vol, .pubnonperiodical_publisher, .pubnonperiodical_city, .pubnonperiodical_state'
          )
            .parent()
            .show()
          $('.pubnonperiodical_start')
            .parent()
            .parent()
            .parent()
            .parent()
            .parent()
            .parent()
            .show()
        }
      )
    }
    if (
      sv == 'book' ||
      sv == 'chapter' ||
      sv == 'introduction' ||
      sv == 'brochure' ||
      sv == 'report'
    ) {
      $('#main_pubnonperiodical_suffix_pubonline').click(function (event) {
        $('.pubnonperiodical_publisher, .pubnonperiodical_city, .pubnonperiodical_state')
          .parent()
          .hide()
          .find('input')
          .val('')
        $('.pubnonperiodical_start')
          .parent()
          .parent()
          .parent()
          .parent()
          .parent()
          .parent()
          .hide()
          .find('input')
          .val('')
      })
      $('#main_pubnonperiodical, #main_pubnonperiodical_suffix_pubdatabase').click(
        function (event) {
          $(
            '.pubnonperiodical_publisher, .pubnonperiodical_city, .pubnonperiodical_state'
          )
            .parent()
            .show()
          $('.pubnonperiodical_start')
            .parent()
            .parent()
            .parent()
            .parent()
            .parent()
            .parent()
            .show()
        }
      )
    }
  }

  //court case
  $('.slip-page').hide()
  $('.slip-yes').click(function (event) {
    $('.slip-page').show()
    $('.noslip-pub').hide()
  })
  $('.slip-no').click(function (event) {
    $('.slip-page').hide()
    $('.noslip-pub').show()
  })
  $('.slip-page').hide()
  $('.noslip-pub').show()

  $('.db_elements').hide()
  $('.db-recfoundyes').hide()

  $('.db-yes').click(function (event) {
    $('.db_elements').show()
  })
  $('.db-no').click(function (event) {
    $('.db_elements').hide()
  })
  $('.recfound-yes').click(function (event) {
    $('.db-recfoundyes').show()
    $('.db-recfoundno').hide()
  })
  $('.recfound-no').click(function (event) {
    $('.db-recfoundyes').hide()
    $('.db-recfoundno').show()
  })

  //journal
  if ($('#source').val() == 'journal' && $('#style').val() == 'mla7') {
    $('#main_pubjournal_suffix_pubonline_2').click(function () {
      $('.pubonline tr').each(function (i) {
        if (i == 1 || i == 2 || i == 4) {
          $(this).hide()
        }
      })
    })
    $('input#main_pubjournal_suffix_pubonline').click(function () {
      $('.pubonline tr').show()
    })
  }

  //interview
  $('.interview-personalsection').hide()

  $('.interview-personal').click(function (event) {
    $('.interview-othersection').hide()
    $('.interview-personalsection').show()
  })
  $('.interview-other').click(function (event) {
    $('.interview-othersection').show()
    $('.interview-personalsection').hide()
  })

  //report
  $('.report-ericntis').hide()
  $('.report-ericntis-yes').click(function (event) {
    $('.report-ericntis').show()
  })
  $('.report-ericntis-no').click(function (event) {
    $('.report-ericntis').hide()
  })
  $('.report_type').click(function (event) {
    $('.report_label_number').find('label').text('Number:')
  })
  $('.report_type_custom').click(function (event) {
    $('.report_label_number').find('label').text('Description:')
  })

  //photo
  $('.photo-personal').hide()
  $('.photo-type')
    .find('input')
    .click(function (event) {
      if ($(this).val() == 'personal') {
        $('.photo-personal').show()
        $('.photo-impersonal').hide()
        $('.photo-impersonal')
          .find('input')
          .each(function (i) {
            $(this).val('')
            $(this).attr('checked', '')
          })
      } else {
        $('.photo-impersonal').show()
        $('.photo-personal').hide()
        $('.photo-personal')
          .find('input')
          .each(function (i) {
            $(this).val('')
            $(this).attr('checked', '')
          })
      }
    })

  //online database

  $('#pubdatabase_keyword').click(function (event) {
    $('#pubdatabase_searchtext').attr('placeholder', 'Type keyword here').select()
  })
  $('#pubdatabase_path').click(function (event) {
    $('#pubdatabase_searchtext')
      .attr('placeholder', 'Ex: Science; Biology; Birds')
      .select()
  })
  $('#pubdatabase_url').click(function (event) {
    $('#pubdatabase_searchtext').attr('placeholder', 'http://')
  })

  //blog
  $('.blog-posttype')
    .find('input')
    .click(function (event) {
      let section = 'blog-' + $(this).val()
      $('.blog-sections, .blog-contrib')
        .find('input')
        .each(function (i) {
          $(this).val('')
          $(this).attr('checked', '')
        })

      $('.blog-sections').hide()
      $('.' + section).show()

      let section_contrib_title = {}

      if (section == 'blog-comment') {
        section_contrib_title['author'] = 'Commenter'
      } else if (section == 'blog-review') {
        section_contrib_title['reviewer'] = 'Reviewer'
        section_contrib_title['reviewed'] = 'Work author'
      } else if (section == 'blog-interview') {
        section_contrib_title['interviewee'] = 'Interviewee'
        section_contrib_title['interviewer'] = 'Interviewer'
      } else {
        section_contrib_title['author'] = 'Article author'
      }

      if ($('#style').val() == 'mla7' || $('#style').val() == 'mla') {
        section_contrib_title['editor'] = 'Site editor'
      }

      let contribtitle = $("select[name^='contributors[function']")
      contribtitle.empty()
      for (let key in section_contrib_title) {
        let option =
          '<option value="' + key + '">' + section_contrib_title[key] + '</option>'
        contribtitle.append(option)
      }
    })

  //song
  $('.song').hide()
  $('.musicalrecording-song').click(function (event) {
    $('.song').show()
    $('.band').hide()
    $('.wholerecording').hide().find('input, select').val('')
  })
  $('.musicalrecording-whole').click(function (event) {
    $('.song').hide().find('input, select').val('')
    $('.wholerecording').show()
    $('.band').show()
  })

  if ($('#source').val() == 'musicalrecording') {
    $('.tabheader').click(function (event) {
      if ($(this).attr('id') == 'suffix_pubonline') {
        $('.recording_type').hide().find('input').prop('checked', false)
      } else {
        $('.recording_type').show()
      }
    })
  }

  //conference proceedings
  if ($('#source').val() == 'conference') {
    $('.tabheader').click(function (event) {
      if ($(this).attr('id') == 'main_pubmagazine') {
        $('.conference_element').hide()
      } else {
        $('.conference_element').show()
      }
    })
  }

  //film
  if ($('#source').val() == 'film') {
    $('.tabheader:not(#main_pubfilm_suffix_pubdatabase)').click(function (event) {
      $('.pubfilm_mediatype').show()
    })
    $('#main_pubonline, #main_pubfilm_suffix_pubonline').click(function (event) {
      if ($('#main_pubfilm_suffix_pubonline').prop('checked') == true) {
        $('.pubfilm_mediatype').hide().find('input').prop('checked', false)
      } else {
        $('.pubfilm_mediatype').show()
      }
    })
    $(
      '.tabheader#main_pubfilm_suffix_pubdatabase, .pubsuffixheader#main_pubfilm_suffix_pubdatabase'
    ).click(function (event) {
      $('.pubfilm_mediatype').hide().find('input').prop('checked', false)
    })

    $('#mediatypeothervalue').focus(function () {
      $('#mediatypeother').prop('checked', true)
    })
  }

  //fed bill
  $('.fedbill_unenacted').hide()
  $('#fedbill_unenacted').click(function (event) {
    $('.fedbill_unenacted').show()
    $('input[name^="pubfederal[source"]')
      .parent()
      .parent()
      .parent()
      .parent()
      .parent()
      .parent()
      .parent()
      .hide()
    $('input[name^="pubfederal[vol"]')
      .parent()
      .parent()
      .parent()
      .parent()
      .parent()
      .parent()
      .parent()
      .hide()
    $('input[name^="pubfederal[start"]')
      .parent()
      .parent()
      .parent()
      .parent()
      .parent()
      .parent()
      .parent()
      .hide()
  })
  $('#fedbill_enacted').click(function (event) {
    $('.fedbill_unenacted').hide()
    $('input[name^="pubfederal[source"]')
      .parent()
      .parent()
      .parent()
      .parent()
      .parent()
      .parent()
      .parent()
      .show()
    $('input[name^="pubfederal[vol"]')
      .parent()
      .parent()
      .parent()
      .parent()
      .parent()
      .parent()
      .parent()
      .show()
    $('input[name^="pubfederal[start"]')
      .parent()
      .parent()
      .parent()
      .parent()
      .parent()
      .parent()
      .parent()
      .show()
  })

  //statute
  $('#statute_uncodified').click(function (event) {
    $('.statute_uncodified').show()
    $('.statute_codified').hide()
    $('input[name^="pubfederal[congress"]').parent().show()
  })
  $('#statute_codified')
    .click(function (event) {
      $('.statute_codified').show()
      $('.statute_uncodified').hide()
      $('input[name^="pubfederal[congress"]').parent().hide()
    })
    .click()

  //tv
  $('.tv_notitle_radio').click(function (event) {
    $('.tv_notitle').hide().val('')
  })
  $('.tv_title_radio').click(function (event) {
    $('.tv_notitle').show()
  })

  if ($('#source').val() == 'tv') {
    $('.tabheader').click(function (event) {
      $('.pubtvr_mediatype').show()
      if ($(this).attr('id') == 'main_pubtvr_suffix_pubonline') {
        $('.pubtvr_mediatype').hide().find('input').prop('checked', false)
      }
    })
  }

  /**
   * Citation-specific functions
   */
  /**
   * Hide form loading message
   */
  $('#form_load_msg').slideUp()

  /**
   * Add listeners to pubheader tabs.
   */
  $('.tabheader').click(function (e) {
    pubHideOldActive()
    let pubid = $(this).attr('id')

    //show puboptions
    $('.puboptions_' + pubid).show()
    let subid = $('.puboptions_' + pubid + ' input:checked')
      .eq(0)
      .attr('id')

    if (subid) {
      pubShowNewActive(subid)
    } else {
      pubShowNewActive(pubid)
    }

    $('.tabheader button').attr('aria-pressed', 'false')
    $('.tabactive').addClass('tabinactive')
    $('.tabactive').css('border-top', '')
    $('.tabactive').removeClass('tabactive')

    $(this).find('button').attr('aria-pressed', 'true')
    $(this).addClass('tabactive')
    $('.tabactive').css('border-top', `3px solid ${theme.Colors.primaryColor}`)
    $(this).removeClass('tabinactive')
  })

  $('.pubsuffixheader').click(function (e) {
    pubHideOldActive()
    pubShowNewActive($(this).attr('id'))
    let pubid = $('.tabactive').attr('id')
    $('.puboptions_' + pubid).show()
  })

  /**
   * pubHideOldActive
   * Hides the publication fields that are not active.
   */
  function pubHideOldActive() {
    $('.pub').hide()
    $('#pubtype').val('')
    $('#pubsuffix').val('')
  }

  /**
   * pubShowNewActive
   * Shows the publication fields that are now active.
   */
  function pubShowNewActive(subpubid) {
    let pubs = subpubid.split('_')
    if (pubs[0] == 'main') {
      if (pubs[1] != 'pubnone') {
        $('#pubtype').val(pubs[1])
        $('.' + style + 'suffixhide').show()
      }
      $('.' + pubs[1]).show()
    }
    if (pubs[0] == 'suffix') {
      $('#pubsuffix').val(pubs[1])
      $('.' + pubs[1]).show()
      $('.' + style + 'suffixhide')
        .hide()
        .find('input, select')
        .val('')
    }
    if (pubs[2] == 'main') {
      $('#pubtype').val(pubs[3])
      $('.' + pubs[3]).show()
      $('.' + style + 'suffixhide').show()
    }
    if (pubs[2] == 'suffix') {
      $('#pubsuffix').val(pubs[3])
      $('.' + pubs[3]).show()
      $('.' + style + 'suffixhide')
        .hide()
        .find('input, select')
        .val('')
    }
  }

  /**
   * Show initial publication type
   */
  $('.tabheaders .tabactive').click()
  if (typeof pubtab != 'undefined' && pubtab != '') {
    clickPubTab(pubtab)
  }

  function clickPubTab(pubtab) {
    $('.tabheader div').each(function (i) {
      let tab_text = $(this).text()
      if (pubtab == 'pubdatabase') {
        if (tab_text == 'Online database') {
          $(this).parent().click()
        }
      } else if (pubtab == 'pubonline') {
        if (
          tab_text == 'Online' ||
          tab_text == 'Website' ||
          tab_text == 'From a website'
        ) {
          $(this).parent().click()
        }
      }
    })
  }

  /**
   * Add a new contributor row
   * Happens when someone clicks "Add" next to contributors.
   */
  let clickHandlerForContribAdd = function (event, sendRioevent = true) {
    if (sendRioevent) {
      onUserClickAddContributorsCTA()
    }
    let last_row = $('.contributors_table_row:last')

    let clone = last_row.clone()
    clone.find('input').each(function (n) {
      $(this).val('')
    })
    last_row.after(clone)
    clone.find('.contributors_function:last').eq(0).focus()
    return false
  }
  $('body').on('click', 'a.contrib_add', clickHandlerForContribAdd)
  eventsToUnmount.push({
    target: 'body',
    args: ['click', 'a.contrib_add', clickHandlerForContribAdd],
  })

  /**
   * Delete a contributor row
   * Happens when someone clicks "Del" next to contributors.
   */
  let clickHandlerForContribRemove = function (event) {
    let count = $('.contributors_table_row').length
    if (count > 1) {
      $(this).parent().parent().remove()
    } else {
      $(this).parent().parent().find('input').val('')
    }
  }
  $('body').on('click', 'a.contrib_remove', clickHandlerForContribRemove)
  eventsToUnmount.push({
    target: 'body',
    args: ['click', 'a.contrib_remove', clickHandlerForContribRemove],
  })

  /**
   * When a user clicks "today" next to date accessed,
   * this is activated.
   *
   * @param {Object} scope
   */
  let today = function (scope) {
    $('a.today', scope).click(function (event) {
      let theDate = new Date()
      let day = theDate.getDate()
      let month = theDate.getMonth() + 1
      let year = theDate.getFullYear()
      let parent = $(this).parent().parent()
      parent.find('input.day').eq(0).val(day).change()
      parent.find('select.month').eq(0).prop('selectedIndex', month).change()
      parent.find('input.year').eq(0).val(year).change()
      today(this)
      return false
    })
  }

  /**
   * Slide toggle on the annotation box
   */
  $('#annotation-link').click(function (event) {
    $('#annotation').slideToggle()
  })

  /**
   * Instantiate all functions to scope.
   */
  today($(document))

  //sources that have two contribs: chapter, collection, introduction
  let prepopulate, edit
  if (
    (typeof prepopulate == 'undefined' || prepopulate.length == 0) &&
    typeof edit == 'undefined'
  ) {
    let val = $('#source').val()
    if (val == 'chapter' || val == 'introduction' || val == 'collection') {
      clickHandlerForContribAdd(null, false)
      $('.contributors_function:last').val('author')
      if (val == 'chapter') {
        $('.contributors_function:last').val('editor')
      }
    }
  }

  function inject(dataArray) {
    let field_name

    let otherStuff = ''

    for (let section in dataArray) {
      if (section == 'pubtype') {
        selectPubtype(dataArray[section])
      } else if (section == 'contributors') {
        fillContrib(dataArray[section])
      } else if (section == 'other') {
        otherStuff = dataArray[section]
        if (typeof dataArray[section] == 'object') {
          otherStuff = JSON.stringify(dataArray[section])
        }
        $('#other').val(escape(otherStuff))
      } else {
        for (let field in dataArray[section]) {
          if (field == 'month' || field == 'monthaccessed') {
            dataArray[section][field] = (dataArray[section][field] + '').toLowerCase()
          }
          field_name = section + '[' + field + ''
          let input_name = "[name^='" + field_name + "]']"
          fillValue(input_name, dataArray[section][field])
        }
      }
    }

    if (dataArray.annotation) {
      $('#annotation').find('textarea').val(dataArray.annotation)
      $('#annotation').show()
      $('a.annotation_add').hide()
      $('#annotation').css({ 'margin-top': '-40px' })
    }
  }

  /**
   * fillValue
   * Fills out all values outside of contributors.
   * @param {Object} data form data
   */
  function fillValue(field, data) {
    if ($(field).is('textarea')) {
      $(field).html(data)
    }
    let type = $(field).attr('type')
    switch (type) {
      case 'text':
        $(field).val(data)
        break
      case 'radio':
        $(field).each(function (n) {
          if ($(this).val() == data) {
            $(this).attr('checked', 'checked')
            $(this).click()
          }
        })
        break
      case 'checkbox':
        if (data.length > 0) {
          $(field).click()
        }
        break
      default:
        $(field).val(data)
    }
  }

  function selectPubtype(data) {
    if (typeof pubtab !== 'undefined' && pubtab.length > 0) {
      return
    }

    // let pubtab = '';
    if (data.length == 0) {
      return
    }
    if (data['main']) {
      pubtab = 'main_' + data['main']
      if (data['suffix']) {
        pubtab += '_suffix_' + data['suffix']
      }
    } else if (data['suffix']) {
      pubtab = 'suffix_' + data['suffix']
    }
    let s = $('.pubsuffixheader').filter('#' + pubtab)
    let sl = s.length
    if (sl > 0) {
      s.click()
      let p = s.parent().children('input').eq(0).attr('id')
      $('.tabheader')
        .filter('#' + p)
        .click()
    } else {
      $('.tabheader')
        .filter('#' + pubtab)
        .click()
    }
  }

  /**
   * fillContrib
   * Fills out the contributors upon edit.
   * @param {Object} data contributor data
   */
  function fillContrib(data) {
    $('.contributors_function').val($('.contributors_function').eq(0).val())
    $('.contributors_first').val('')
    $('.contributors_middle').val('')
    $('.contributors_last').val('')
    $('.contributors_suffix').val('')

    let length = data.length

    for (let k = 0; k < length; k++) {
      if (k < length - 1) {
        clickHandlerForContribAdd(null, false)
      }
      let orig_function = $('.contributors_function').eq(k).val()
      $('.contributors_function').eq(k).val(data[k]['function'])
      if ($('.contributors_function').eq(k).find(':selected').text().length == 0) {
        $('.contributors_function').eq(k).val(orig_function)
      }
      $('.contributors_first').eq(k).val(data[k]['first'])
      $('.contributors_middle').eq(k).val(data[k]['middle'])
      $('.contributors_last').eq(k).val(data[k]['last'])
      if (data[k]['data'] && data[k]['data']['suffix'])
        $('.contributors_suffix').eq(k).val(data[k]['data']['suffix'])
    }
  }
  // -------
  // End of the legacy Js.

  // Missing annotation textarea needs to be added before filling out the form
  addAnnotationLink(onUserClickAddAnnotationCTA)
  if (citation) {
    inject(citation)
    initialCitationData = citation
  }

  redesignForm(style, onChangeSourceType, theme)
  checkMissingFields()
}
